import React from 'react';
import { Button, ButtonProps } from '@antimatterhq/ui/components/button';
import { IconType } from '@antimatterhq/ui/components/icon';
import { cn } from '@/lib/utils';

export type RowButtonProps = Omit<
  ButtonProps,
  'leftIcon' | 'rightIcon' | 'iconOnly' | 'children' | 'variant' | 'size'
> & {
  icon: IconType;
};

export const RowButton = React.forwardRef<HTMLButtonElement, RowButtonProps>(
  ({ icon, className, ...props }, ref) => (
    <Button
      variant="ghost"
      size="small"
      leftIcon={icon}
      className={cn('p-0', className)}
      {...props}
      ref={ref}
    />
  ),
);

RowButton.displayName = 'RowButton';
